import { HorizontalStepper } from "components/molecules/HorizontalStepper";
import { VerticalStepper } from "components/molecules/VerticalStepper";
import { ReactNode } from "react";

interface Step {
  icon?: ReactNode;
  iconLabel?: string;
  title?: string;
  description?: string;
}

export interface StepperProps {
  steps: Step[];
  currentStep?: number;
  vertical?: boolean;
  className?: string;
}

/**
 * @param steps [Step[]]
 * @param currentStep [number]
 * @param vertical [boolean]
 * @param className [string]
 * @returns JSX.Element
 */
export const Stepper = ({
  steps,
  currentStep,
  vertical,
  className,
}: StepperProps) =>
  vertical ? (
    <VerticalStepper steps={steps} className={className} />
  ) : (
    <HorizontalStepper
      steps={steps}
      currentStep={currentStep}
      className={className}
    />
  );
